"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/material/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _common = require("../../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX = 'BrandDrawerContent';
var classes = {
  closeButton: "".concat(PREFIX, "-closeButton"),
  closeIcon: "".concat(PREFIX, "-closeIcon"),
  fullList: "".concat(PREFIX, "-fullList")
};
var Root = (0, _styles.styled)('div')(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, _defineProperty(_ref2, "& .".concat(classes.closeButton), {
    position: 'absolute',
    top: '10px',
    right: 0
  }), _defineProperty(_ref2, "& .".concat(classes.closeIcon), {
    color: theme.palette.font.primary
  }), _defineProperty(_ref2, "&.".concat(classes.fullList), (0, _common.drawerContentStyles)(theme)), _ref2;
});

var BrandDrawerContent = function BrandDrawerContent(_ref3) {
  var children = _ref3.children,
      toggleDrawer = _ref3.toggleDrawer,
      onClose = _ref3.onClose,
      className = _ref3.className;
  return /*#__PURE__*/_react.default.createElement(Root, {
    className: (0, _clsx2.default)(classes.fullList, _defineProperty({}, className, !!className)),
    role: "presentation",
    onClick: toggleDrawer,
    onKeyDown: toggleDrawer
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: classes.closeButton,
    onClick: onClose,
    size: "large"
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    className: classes.closeIcon
  })), children);
};

BrandDrawerContent.propTypes = {
  children: _propTypes.default.any,
  toggleDrawer: _propTypes.default.func,
  className: _propTypes.default.string
};
var _default = BrandDrawerContent;
exports.default = _default;